import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import _ from 'underscore'
import constants from '../constants'

Vue.use(Vuex)

export default new Vuex.Store({

	state: {
		
		time: {
			current: moment().utc().unix(),
			offset: 0
		},

		category: 0,

		data: {
			teams: [],
			tasks: [],
			bookmarked: [],
			categories: [],
			settings: false,
			session: false
		}

	},

	getters: {
		
		time: function(state) {

			return state.time.current + state.time.offset
			
		},

		'time/current': function(state) {

			return state.time.current + state.time.offset

		},

		'time/offset': function(state) {

			return state.time.offset

		},

		'time/raw': function(state) {

			return state.time.current

		},

		teams: function(state) {

			return state.data.teams

		},

		categories: function(state) {

			return state.data.categories

		},

		tasks: function(state) {

			return state.data.tasks

		},

		category: function(state) {

			return _.findWhere(state.data.categories, {
				id: state.category
			})

		},	

		'category/tasks': function(state) {

			return _.where(state.data.tasks, {
				category: state.category
			})

		},

		session: function(state) {

			return state.data.session

		},

		settings: function(state) {

			return state.data.settings

		},

		'session/tasks': function(state) {

			var tasks = []

			_.each(state.data.session.tasks, function(task) {

				tasks[task.id] = task

			})

			return tasks

		},

		'session/bookmarked': function(state) {

			return state.data.session.bookmarked

		},

		'session/tasks/completed': function(state) {

			if (state.data.session) {

				return _.pluck(_.where(state.data.session.tasks, {
					status: constants.task.complete
				}), 'id')

			} else {

				return []

			}

		}

	},

	mutations: {

		'time/current': function(state, value) {

			state.time.current = value

		},

		'time/offset': function(state, value) {

			state.time.offset = value

		},

		teams: function(state, value) {

			state.data.teams = value

		},

		tasks: function(state, value) {

			state.data.tasks = value

		},

		category: function(state, value) {

			state.category = value

		},

		categories: function(state, value) {

			state.data.categories = value
			state.category = value[0].id

		},

		session: function(state, value) {

			state.data.session = value

		},

		'session/permit/feed': function(state, value) {

			state.data.session.permit.feed = value

		},

		settings: function(state, value) {

			state.data.settings = value

		}

	},

	actions: {

	}

})
